// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.combinations_textFieldRoot__ITL-r {
    color: white;
}

.combinations_card__N\\+L5r {
    height: 100%;
    overflow: auto;
}

.combinations_cardTitle__J\\+f9e {
    background-color: rgba(255, 255, 255, 0.8);
    position: sticky;
    top: 0;
    z-index: 100;
}

.combinations_cardContent__SgxLJ {
    height: calc(100% - 45px);
    overflow: hidden;
    padding: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Combinations/combinations.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB","sourcesContent":[".textFieldRoot {\n    color: white;\n}\n\n.card {\n    height: 100%;\n    overflow: auto;\n}\n\n.cardTitle {\n    background-color: rgba(255, 255, 255, 0.8);\n    position: sticky;\n    top: 0;\n    z-index: 100;\n}\n\n.cardContent {\n    height: calc(100% - 45px);\n    overflow: hidden;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textFieldRoot": `combinations_textFieldRoot__ITL-r`,
	"card": `combinations_card__N+L5r`,
	"cardTitle": `combinations_cardTitle__J+f9e`,
	"cardContent": `combinations_cardContent__SgxLJ`
};
export default ___CSS_LOADER_EXPORT___;
